module.exports = __webpack_public_path__ + "static/media/drive_2.9c7b0ee8.jpg";